import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function RicohSolutions() {
  return <DetailPage type="product" id="ricoh-solutions" />;
}
